
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 7.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM8.75 10a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z"}}),_c('path',{attrs:{"d":"M13.273 5.497a.885.885 0 01-1.03-.708l-.325-1.77a.442.442 0 00-.344-.353 7.59 7.59 0 00-3.149 0 .442.442 0 00-.344.353l-.323 1.77a.888.888 0 01-1.17.672l-1.7-.605a.444.444 0 00-.477.119 7.487 7.487 0 00-1.577 2.716.44.44 0 00.135.473l1.377 1.164a.88.88 0 010 1.345L2.97 11.835a.44.44 0 00-.135.473 7.482 7.482 0 001.578 2.716.443.443 0 00.478.119l1.7-.605a.886.886 0 011.17.672l.322 1.77a.442.442 0 00.344.351c1.039.22 2.112.22 3.15 0a.442.442 0 00.343-.35l.325-1.77a.89.89 0 011.17-.673l1.699.605c.168.06.357.012.477-.119a7.488 7.488 0 001.578-2.716.44.44 0 00-.136-.473l-1.377-1.164a.878.878 0 010-1.345l1.377-1.163a.44.44 0 00.136-.473 7.481 7.481 0 00-1.58-2.716.444.444 0 00-.478-.119l-1.7.605a.89.89 0 01-.139.038l.002-.002zm-8.276.726l1.172.416a2.138 2.138 0 002.819-1.625l.22-1.213a6.381 6.381 0 011.582 0l.223 1.213a2.135 2.135 0 002.818 1.625L15 6.22c.319.418.584.873.787 1.355l-.942.797a2.13 2.13 0 000 3.255l.944.796A6.229 6.229 0 0115 13.779l-1.171-.418a2.137 2.137 0 00-2.819 1.625L10.79 16.2a6.367 6.367 0 01-1.582 0l-.22-1.213a2.135 2.135 0 00-2.82-1.625L5 13.78a6.233 6.233 0 01-.787-1.355l.942-.798a2.13 2.13 0 000-3.253l-.944-.797c.205-.482.47-.937.788-1.355l-.002.002z"}})])
          )
        }
      }
    